import { useHistory } from "react-router-dom";
import VuiBox from "components/VuiBox";
import VuiButton from "components/VuiButton";

const ACTIONS = [
  { label: "➕ Add Company Client",  path: "/client-profiles" },
  { label: "👤 Add Individual",      path: "/client-profiles" },
  { label: "📋 View All Jobs",       path: "/client-profiles" },
  { label: "📁 Client Profiles",     path: "/client-profiles" },
];

export default function QuickActionsWidget({ tenantId }) {
  const history = useHistory();
  return (
    <VuiBox p={2} display="flex" flexDirection="column" height="100%">
      {ACTIONS.map(({ label, path }) => (
        <VuiButton
          key={label}
          variant="outlined"
          size="small"
          color="info"
          fullWidth
          onClick={() => history.push(path)}
          sx={{ mb: 1, justifyContent: "flex-start", textTransform: "none", fontSize: "0.78rem" }}
        >
          {label}
        </VuiButton>
      ))}
    </VuiBox>
  );
}

